import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';

class Tab extends s {
    constructor() {
        super(...arguments);
        this.selected = false;
        this.withRestrictedContent = false;
    }
    firstUpdated() {
        var _a;
        (_a = this.querySelector('.seo-title')) === null || _a === void 0 ? void 0 : _a.remove();
        const restricted = this.querySelector('restricted-content');
        if (restricted) {
            this.withRestrictedContent = true;
            const container = document.querySelector('.container');
            container === null || container === void 0 ? void 0 : container.append(restricted);
        }
    }
    render() {
        return this.selected
            ? x `<slot></slot><slot name="restricted-content"></slot>`
            : null;
    }
}
__decorate([
    n({ type: String, reflect: true })
], Tab.prototype, "name", void 0);
__decorate([
    n({ type: String, reflect: true })
], Tab.prototype, "tabId", void 0);
__decorate([
    n({ type: Boolean, reflect: true })
], Tab.prototype, "selected", void 0);
__decorate([
    n({ type: Boolean, reflect: true })
], Tab.prototype, "withRestrictedContent", void 0);
__decorate([
    n()
], Tab.prototype, "redirectUrl", void 0);
customElements.define('tab-item', Tab);

export { Tab };
